import { fridaySingleLetterAbbreviation } from 'owa-locstrings/lib/strings/fridaysingleletterabbreviation.locstring.json';
import { thursdaySingleLetterAbbreviation } from 'owa-locstrings/lib/strings/thursdaysingleletterabbreviation.locstring.json';
import { wednesdaySingleLetterAbbreviation } from 'owa-locstrings/lib/strings/wednesdaysingleletterabbreviation.locstring.json';
import { tuesdaySingleLetterAbbreviation } from 'owa-locstrings/lib/strings/tuesdaysingleletterabbreviation.locstring.json';
import { mondaySingleLetterAbbreviation } from 'owa-locstrings/lib/strings/mondaysingleletterabbreviation.locstring.json';
import { sundaySingleLetterAbbreviation } from 'owa-locstrings/lib/strings/sundaysingleletterabbreviation.locstring.json';
import { saturdaySingleLetterAbbreviation } from 'owa-locstrings/lib/strings/saturdaysingleletterabbreviation.locstring.json';
import loc from 'owa-localize';

import {
    SATURDAY_KEY,
    SUNDAY_KEY,
    MONDAY_KEY,
    TUESDAY_KEY,
    WEDNESDAY_KEY,
    THURSDAY_KEY,
    FRIDAY_KEY,
} from 'owa-recurrence-types';

export default function getRecurrenceDaySingleLetterString(day: string): string {
    switch (day) {
        case SATURDAY_KEY: {
            return loc(saturdaySingleLetterAbbreviation);
        }
        case SUNDAY_KEY: {
            return loc(sundaySingleLetterAbbreviation);
        }
        case MONDAY_KEY: {
            return loc(mondaySingleLetterAbbreviation);
        }
        case TUESDAY_KEY: {
            return loc(tuesdaySingleLetterAbbreviation);
        }
        case WEDNESDAY_KEY: {
            return loc(wednesdaySingleLetterAbbreviation);
        }
        case THURSDAY_KEY: {
            return loc(thursdaySingleLetterAbbreviation);
        }
        case FRIDAY_KEY: {
            return loc(fridaySingleLetterAbbreviation);
        }
        default: {
            return '';
        }
    }
}
